import { merge } from 'lodash';

export const initialState = {
    email: '',
    phone: '',
    url: '',
    headerText: '',
    productHelpName: '',
    sectionTitle: '',
    studentDisplayText: '',
    supportWebsiteDisplayText: '',
    showToStaff: false,
    showToStudents: false,
    toastText: '',
    showToast: false,
    originalHelpDeskInfo: {}
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_HELP_DESK_INFO':
            return {
                ...state,
                ...action.elements,
                originalHelpDeskInfo: action.elements
            };
        case 'HIDE_TOAST':
            return {
                ...state,
                showToast: false,
                toastText: ''
            };
        case 'SET_VALUE':
            return merge({}, state, action.elements);
        case 'RESET_CHANGES':
            return {
                ...state,
                ...state.originalHelpDeskInfo,
                toastText: 'Your changes have been cleared.',
                showToast: true
            }
        case 'CHANGES_SAVED':
            return {
                ...state,
                originalHelpDeskInfo: state,
                toastText: 'Your changes have been saved.',
                showToast: true
            }
    }
}
